import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

/*
* TODO: add to separate file to prevent eslint errors?
*/
enum BackGroundCheckStatus {
  PENDING = 'pending',
  COMPLETE = 'complete',
  CANCELLED = 'cancelled',
  NOT_SUBMITTED = 'not submitted'
}

@inheritSerialization(AbstractModel)
export class BackgroundCheck extends AbstractModel {
  @autoserialize
  tncDriverProfileId: number;

  @autoserialize
  sterlingScreeningId: number;

  @autoserialize
  sterlingCandidateId: number;

  @autoserializeAs(BackGroundCheckStatus)
  backgroundCheckStatus: string;
}
